
    import '/home/ec2-user/Youlify-Design/components/checkbox/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["checkbox-demo-basic","checkbox-demo-disabled","checkbox-demo-controller","checkbox-demo-group","checkbox-demo-check-all","checkbox-demo-layout","checkbox-demo-debug-line","checkbox-demo-debug-disable-popover","checkbox-demo-custom-line-width"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/checkbox/index.en-US.md?type=demo')
};